import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { createContext, useState, } from 'react';
import { useLocation } from 'react-router-dom';
import { instoreOrderNumberFormat } from '../components/shared/order-number-formatter/OrderNumberFormatter';
import { GetOrderDetailsInfo } from '../hooks/order-details-hooks';
import useFetchState from '../hooks/useFetchState';
import { getOrderType } from '../utils/order-details/OrderDetailsUtils';
var defaultState = {
    alertState: null,
    exportAlertState: null,
    localDelivery: false,
    nickName: '',
    orderDetailsData: undefined,
    orderDetailsError: undefined,
    orderDetailsLoaded: false,
    orderDetailsRequestParams: {
        customerAccountId: '',
        orderDetailsRoute: '',
        orderIndex: 0,
        orderNumber: '',
        registerNumber: 0,
        salesDate: '',
        storeNumber: 0,
        transactionId: 0,
    },
    orderIndex: 0,
    deliveryTrackerLoaded: false,
    orderNumber: '',
    setAlertState: function () { return null; },
    setExportAlertState: function () { return null; },
};
// Create the context with a default value
export var OrderDetailsContext = createContext(defaultState);
export var OrderDetialsProvider = function (_a) {
    var _b, _c, _d;
    var children = _a.children, customerType = _a.customerType, customerRole = _a.customerRole;
    // Context's
    var svocID = useThdCustomer().svocID;
    // State
    var _e = useState(null), alertState = _e[0], setAlertState = _e[1];
    var _f = useState(null), exportAlertState = _f[0], setExportAlertState = _f[1];
    // Misc
    var location = useLocation();
    var urlParams = new URLSearchParams(location.search);
    var orderNumber = String(urlParams.get('orderNumber'));
    var orderIndex = Number(urlParams.get('index'));
    var salesDate = String(urlParams.get('salesDate'));
    var storeNumber = Number(urlParams.get('storeNumber'));
    var transactionId = Number(urlParams.get('transactionId'));
    var registerNumber = Number(urlParams.get('registerNumber'));
    var transactionType = String(urlParams.get('transactionType'));
    var nickName = String(urlParams.get('nickName'));
    var localDelivery = Boolean(urlParams.get('localDelivery'));
    orderNumber =
        orderNumber === 'null'
            ? instoreOrderNumberFormat(registerNumber, transactionId, customerType)
            : orderNumber;
    // Generate the request based on the customer type
    var generateOrderDetailsRequest = function () {
        var orderType = getOrderType(orderNumber);
        if (customerType === 'b2b' && orderType === 'ONLINE') {
            if (transactionType === 'R') {
                return {
                    orderDetailsRequest: {
                        searchType: 'online',
                        registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                        salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                        storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                        transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                        transactionType: transactionType !== null && transactionType !== void 0 ? transactionType : '',
                        orderNumber: orderNumber !== null && orderNumber !== void 0 ? orderNumber : '',
                        customerAccountId: svocID,
                        groupAndSortBy: {
                            groupBy: 'fulfillmentType',
                            filterResponse: true,
                        },
                        requestOriginatedFrom: 'orderDetails',
                    },
                };
            }
            return {
                orderDetailsRequest: {
                    searchType: 'online',
                    orderNumber: orderNumber !== null && orderNumber !== void 0 ? orderNumber : '',
                    customerAccountId: svocID,
                    groupAndSortBy: {
                        groupBy: 'fulfillmentType',
                        filterResponse: true,
                    },
                    requestOriginatedFrom: 'orderDetails',
                },
            };
        }
        if (customerType === 'b2b' && orderType === 'INSTORE') {
            return {
                orderDetailsRequest: {
                    searchType: 'instore',
                    registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                    salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                    storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                    transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                    orderNumber: orderNumber !== null && orderNumber !== void 0 ? orderNumber : '',
                    customerAccountId: svocID,
                    groupAndSortBy: {
                        groupBy: 'fulfillmentType',
                        filterResponse: true,
                    },
                    requestOriginatedFrom: 'orderDetails',
                },
            };
        }
        return {
            orderDetailsRequest: {
                searchType: orderType === null || orderType === void 0 ? void 0 : orderType.toLowerCase(),
                orderNumber: orderNumber !== null && orderNumber !== void 0 ? orderNumber : '',
                registerNumber: registerNumber,
                storeNumber: storeNumber,
                transactionId: transactionId,
                salesDate: salesDate,
                transactionType: transactionType,
                requestOriginatedFrom: 'orderDetails',
            },
        };
    };
    // Initializing the order barcode API state hook
    var orderBarcodeApiState = useFetchState();
    var _g = GetOrderDetailsInfo(customerType, customerRole, generateOrderDetailsRequest(), localDelivery), orderDetailsData = _g.orderDetailsData, orderDetailsError = _g.orderDetailsError, orderDetailsLoaded = _g.orderDetailsLoaded, deliveryTrackerLoaded = _g.deliveryTrackerLoaded;
    // Used to pass the request params to the children
    var orderDetailsRequestParams = {
        orderDetailsRoute: location.pathname,
        orderNumber: (_d = (_b = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber) !== null && _b !== void 0 ? _b : (_c = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumbers) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : orderNumber,
        salesDate: salesDate,
        storeNumber: storeNumber,
        transactionId: transactionId,
        registerNumber: registerNumber,
        orderIndex: orderIndex,
        customerAccountId: svocID,
    };
    return (React.createElement(OrderDetailsContext.Provider, { value: {
            orderDetailsData: orderDetailsData,
            orderDetailsError: orderDetailsError,
            orderDetailsLoaded: orderDetailsLoaded,
            alertState: alertState,
            setAlertState: setAlertState,
            exportAlertState: exportAlertState,
            setExportAlertState: setExportAlertState,
            orderDetailsRequestParams: orderDetailsRequestParams,
            orderIndex: orderIndex,
            nickName: nickName,
            localDelivery: localDelivery,
            orderBarcodeApiState: orderBarcodeApiState,
            deliveryTrackerLoaded: deliveryTrackerLoaded,
            orderNumber: orderNumber,
        } }, children));
};
